import { useEffect, useRef } from 'react';

const IframeResizer = () => {
  const iframeTypeRef = useRef<string>('');
  const resizeObserverRef = useRef<ResizeObserver | null>(null);
  const lastHeightRef = useRef<number>(0);

  useEffect(() => {
    const handleMessage = (e: MessageEvent) => {
      if (window.self !== window.top) {
        if (typeof e.data === 'object') {
          iframeTypeRef.current = e.data.type;

          // Only update if height changed by more than 5px
          const heightDiff = Math.abs(
            document.body.clientHeight - lastHeightRef.current,
          );
          if (heightDiff > 5) {
            lastHeightRef.current = document.body.clientHeight;
            e.data.height = document.body.clientHeight;
            window.parent.postMessage(e.data, '*');
          }
        }
      }
    };

    window.addEventListener('message', handleMessage);

    resizeObserverRef.current = new ResizeObserver((entries) => {
      if (!iframeTypeRef.current) return;

      const currentHeight = entries[0].target.clientHeight;

      // Only send message if height changed by more than 5px
      const heightDiff = Math.abs(currentHeight - lastHeightRef.current);
      if (heightDiff > 5) {
        lastHeightRef.current = currentHeight;
        window.parent.postMessage(
          {
            action: 'resize',
            height: currentHeight,
            type: iframeTypeRef.current,
          },
          '*',
        );
      }
    });

    resizeObserverRef.current.observe(document.body);

    return () => {
      window.removeEventListener('message', handleMessage);
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
    };
  }, []);

  return null;
};

export default IframeResizer;
